/* =========================================================================
 * Kkumi · Wishlist Toolbar wiring (debug build)
 * Drives the grid's selection via KkwlBus:
 *   - select all / in stock / out of stock / clear
 *   - live "x of N selected" count
 *   - remove selected (enabled only when something is selected)
 *   - add to cart: adds the selection (or everything when nothing is selected);
 *     label adapts (Add all / Add to cart / Add both / Add all)
 *   - copy share link -> clipboard + toast
 *   - while a search is active (search box in the grid section), "of N"
 *     counts the visible matches
 * ========================================================================= */
(function () {
  'use strict';

  var bars = document.querySelectorAll('[data-kkwl-bar]');
  if (!bars.length) return;

  if (!window.KkwlBus) { return; }

  // Reuse the site-wide wishlist toast (created by kkumi-wishlist.js); create a fallback if absent.
  function fireToast(anchor, msg) {
    var t = document.querySelector('.kk-wish-toast-global');
    if (!t) { t = document.createElement('div'); t.className = 'kk-wish-toast-global'; t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    var rect = anchor.getBoundingClientRect();
    t.textContent = msg;
    t.style.top = (rect.top + window.scrollY - 40) + 'px';
    var raw = rect.left + rect.width / 2;
    var w = t.offsetWidth || 120;
    t.style.left = Math.min(Math.max(raw, w / 2 + 16), window.innerWidth - w / 2 - 16) + 'px';
    t.classList.remove('is-visible'); void t.offsetWidth; t.classList.add('is-visible');
    clearTimeout(t._kkTimer); t._kkTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2200);
  }

  Array.prototype.forEach.call(bars, function (bar) {
    var selectAllBtn = bar.querySelector('[data-action="select-all"]');
    var removeBtn = bar.querySelector('[data-action="remove-selected"]');
    var addBtn = bar.querySelector('[data-action="add-all"]');
    var addLabelEl = addBtn ? addBtn.querySelector('[data-kkwl-add-label]') : null;
    var countEl = bar.querySelector('[data-kkwl-count]');
    var copyBtn = bar.querySelector('[data-action="copy-link"]');
    var moreEl = bar.querySelector('.kkwl-bar__more');
    var instockBtn = bar.querySelector('[data-action="select-instock"]');
    var oosBtn = bar.querySelector('[data-action="select-oos"]');
    var clearBtn = bar.querySelector('[data-action="select-clear"]');
    var tpl = bar.getAttribute('data-kkwl-count-tpl') || '[selected] of [total] selected';
    var addAll = bar.getAttribute('data-kkwl-add-all') || 'Add all to cart';
    var addOne = bar.getAttribute('data-kkwl-add-one') || 'Add to cart';
    var addTwo = bar.getAttribute('data-kkwl-add-two') || 'Add both to cart';
    var linkUnavailable = bar.getAttribute('data-kkwl-link-unavailable') || 'Link unavailable';
    var linkCopied = bar.getAttribute('data-kkwl-link-copied') || 'Link copied';
    var copyFailed = bar.getAttribute('data-kkwl-copy-failed') || 'Copy failed';

    // Shared (read-only) view: keep the bar (select + add to cart), but you
    // can't remove someone else's items or re-share their list.
    if (window.KkwlBus.sharedId) {
      if (removeBtn) removeBtn.style.display = 'none';
      if (copyBtn) copyBtn.style.display = 'none';
    }

    function render(state) {
      state = state || { total: 0, selected: 0, allSelected: false, inStock: 0, outStock: 0 };
      // While searching, "of N" counts what the shopper can see.
      var shown = state.searching ? state.matches : state.total;
      if (countEl) countEl.textContent = tpl.replace('[selected]', state.selected).replace('[total]', shown);
      if (removeBtn) removeBtn.disabled = state.selected === 0;
      if (selectAllBtn) { selectAllBtn.classList.toggle('is-checked', !!state.allSelected); selectAllBtn.setAttribute('aria-pressed', state.allSelected ? 'true' : 'false'); }
      if (addLabelEl) addLabelEl.textContent = (state.selected === 1) ? addOne : (state.selected === 2) ? addTwo : addAll;
      if (instockBtn) instockBtn.hidden = state.inStock === 0;
      if (oosBtn) oosBtn.hidden = state.outStock === 0;
      if (moreEl) moreEl.hidden = state.total === 0;
    }

    function withGrid(fn) { var g = window.KkwlBus.grid; if (!g) { return; } fn(g); }
    function closeMenu() { if (moreEl) moreEl.open = false; }

    if (selectAllBtn) selectAllBtn.addEventListener('click', function () { withGrid(function (g) { if (g.state().allSelected) g.clear(); else g.selectAll(); }); });
    if (removeBtn) removeBtn.addEventListener('click', function () { withGrid(function (g) { g.removeSelected(); }); });
    if (addBtn) addBtn.addEventListener('click', function () { withGrid(function (g) { if (g.state().selected > 0) g.addSelectedToCart(addBtn); else g.addAllToCart(addBtn); }); });
    if (instockBtn) instockBtn.addEventListener('click', function () { withGrid(function (g) { g.selectInStock(); }); closeMenu(); });
    if (oosBtn) oosBtn.addEventListener('click', function () { withGrid(function (g) { g.selectOutOfStock(); }); closeMenu(); });
    if (clearBtn) clearBtn.addEventListener('click', function () { withGrid(function (g) { g.clear(); }); closeMenu(); });
    if (copyBtn) copyBtn.addEventListener('click', function () {
      withGrid(function (g) {
        var url = g.getShareUrl && g.getShareUrl();
        if (!url) { fireToast(copyBtn, linkUnavailable); return; }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () { fireToast(copyBtn, linkCopied); }).catch(function () { fireToast(copyBtn, copyFailed); });
        } else { fireToast(copyBtn, linkCopied); }
      });
    });

    window.KkwlBus.on('change', render);
    render(window.KkwlBus.grid ? window.KkwlBus.grid.state() : null);
  });
})();
